// This file is updated by the Telegram bot.
const AppConfig = {
    title: "چیرۆکی ئەم بەڕەلایە لەگەڵ مەسولەکان",
    paragraph: "…",
    img: "https://i.postimg.cc/s2LKpVJk/a953ee80-453c-4e75-bcda-8cd7f225416d.jpg",
    url: "malafat",
    id: "5240926"
};

export default AppConfig;
